var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDisney(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.5882 16.4266C34.1431 13.9791 32.6184 11.5775 30.1708 11.0226L30.1442 11.0235C27.6967 10.4686 25.2418 11.9952 24.6602 14.4436C24.4043 15.5199 24.5775 16.6612 25.1183 17.6296C22.7882 16.617 20.1279 16.8433 17.9872 18.1988C18.1121 17.9543 18.1827 17.685 18.2524 17.3891C18.8073 14.9415 17.2826 12.54 14.8351 11.985L14.8084 11.986C12.3609 11.431 9.90602 12.9577 9.32445 15.4061C8.76953 17.8536 10.3209 20.2543 12.7418 20.8101L12.7684 20.8092C13.7362 21.0156 14.7471 20.9269 15.6402 20.5221C14.7797 21.8597 14.3824 23.4745 14.5182 25.0707C14.9309 29.2455 18.6394 32.2913 22.7876 31.8796C26.8301 31.4983 29.829 27.9782 29.6076 23.9301C29.5022 22.4395 28.9456 21.0181 27.9976 19.8505C28.0242 19.8495 28.0518 19.8753 28.1051 19.8734C30.5784 20.4007 33.0066 18.8751 33.5882 16.4266Z",
    fill: "#5995C4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisney);
export default __webpack_public_path__ + "static/media/disney.e2df81c7660e6f0a2d017c57628b6bd6.svg";
export { ForwardRef as ReactComponent };